import {Dispatch} from 'react'
import {FACTURACION_TYPES} from '../../constants/facturacion.types'
import {FacturacionAction} from '../../interfaces/facturacion.interface'
import {State} from '../../reducers'
import {validacionEsRequerido} from '../../utils/validaciones'
import {facturacionSetCatalogoSerie} from './facturacionEmision.actions'

// ******************************************************************************************
export const facturacionFormSucursalHandleChange = (formSucursal: any) => ({
  type: FACTURACION_TYPES.FORMSUCURSAL_HANDLE_CHANGE,
  payload: formSucursal,
})

export const facturacionFormSucursalAddError = (error: any) => ({
  type: FACTURACION_TYPES.FORMSUCURSAL_SET_ERRORS,
  payload: error,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const facturacionFormSucursalHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    let {name, value} = e.target
    switch (name) {
      case 'sucursal':
        dispatch(facturacionFormSucursalHandleChange({serie: ''}))
        break
      case 'serie':
        break
      default:
        break
    }
    dispatch(facturacionFormSucursalHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const facturacionFormSucursalOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'sucursal':
        message = validacionEsRequerido(value, message, 'Sucursal', 'requerida')

        let sucursal = getState().facturacion.catalogoSucursal.find(
          (suc) => suc?.idsucursal === value
        )
        dispatch(
          facturacionFormSucursalHandleChange({
            datosSucursal: sucursal || null,
            serie: '',
            datosSerie: null,
          })
        )
        dispatch(facturacionSetCatalogoSerie(sucursal ? sucursal?.Documento : []))
        break
      case 'serie':
        message = validacionEsRequerido(value, message, 'Serie', 'requerida')
        let serie = getState().facturacion.catalogoSerie.find(
          (ser) => ser?.idsucursaldocumento === value
        )
        dispatch(facturacionFormSucursalHandleChange({datosSerie: serie || null}))
        break
      default:
        break
    }
    dispatch(facturacionFormSucursalAddError({[name]: message}))
  }

export const facturacionFormSucursalValidacion = (
  dispatch: Dispatch<FacturacionAction>,
  getState: () => State
) => {
  const {formSucursal, errorsFormSucursal} = getState().facturacion
  // Validaciones
  errorsFormSucursal.sucursal = validacionEsRequerido(
    formSucursal.sucursal,
    errorsFormSucursal.sucursal,
    'Sucursal',
    'requerida'
  )
  errorsFormSucursal.serie = validacionEsRequerido(
    formSucursal.serie,
    errorsFormSucursal.serie,
    'Serie',
    'requerida'
  )
  dispatch(facturacionFormSucursalAddError(errorsFormSucursal))
  if (errorsFormSucursal.sucursal || errorsFormSucursal.serie) return true
  return false
}
